const toDegrees = (radians) => (radians * 180) / Math.PI;

function magnitude(vec) {
  return Math.sqrt(vec.x * vec.x + vec.y * vec.y + vec.z * vec.z);
}

function subtract(a, b) {
  return { x: a.x - b.x, y: a.y - b.y, z: (a.z || 0) - (b.z || 0) };
}

function safeAngle(a, b, c) {
  if (!a || !b || !c) return null;
  const ba = subtract(a, b);
  const bc = subtract(c, b);
  const magBA = magnitude(ba);
  const magBC = magnitude(bc);
  if (!magBA || !magBC) return null;
  const dot = ba.x * bc.x + ba.y * bc.y + (ba.z || 0) * (bc.z || 0);
  const cosine = Math.min(1, Math.max(-1, dot / (magBA * magBC)));
  return toDegrees(Math.acos(cosine));
}

export function kneeAngle(hip, knee, ankle) {
  return safeAngle(hip, knee, ankle);
}

export function elbowAngle(shoulder, elbow, wrist) {
  return safeAngle(shoulder, elbow, wrist);
}

export function torsoIncline(hip, shoulder) {
  if (!hip || !shoulder) return null;
  const delta = subtract(shoulder, hip);
  const vertical = Math.sqrt(delta.y * delta.y + (delta.z || 0) * (delta.z || 0));
  const horizontal = Math.abs(delta.x);
  if (!vertical && !horizontal) return null;
  return toDegrees(Math.atan2(horizontal, vertical));
}

export function estimateLumaFromCanvas(ctx) {
  if (!ctx) return null;
  const { width, height } = ctx.canvas;
  if (!width || !height) return null;
  const sampleSize = 64;
  const stepX = Math.max(1, Math.floor(width / sampleSize));
  const stepY = Math.max(1, Math.floor(height / sampleSize));
  let total = 0;
  let count = 0;

  for (let y = 0; y < height; y += stepY) {
    for (let x = 0; x < width; x += stepX) {
      const data = ctx.getImageData(x, y, 1, 1).data;
      const luma = 0.2126 * data[0] + 0.7152 * data[1] + 0.0722 * data[2];
      total += luma;
      count += 1;
    }
  }

  if (!count) return null;
  return total / count / 255;
}
